/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desk_Sso_RedirectingInputs */

const vi_desk_sso_redirecting = /** @type {(inputs: Desk_Sso_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chuyển sang trang hỗ trợ…`)
};

/**

* @param {Desk_Sso_RedirectingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const desk_sso_redirecting = /** @type {((inputs?: Desk_Sso_RedirectingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desk_Sso_RedirectingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_desk_sso_redirecting(inputs)
});